import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { Plus } from "lucide-react";
import { FC, ReactNode } from "react";

interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  illustration: ReactNode;
}

const EmptyWidgetContent: FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  illustration,
}) => {
  return (
    <div className="flex size-full items-center justify-center">
      <div className="flex  max-w-[300px] flex-col items-center text-center">
        <div className="mb-6 flex size-16 items-center justify-center rounded-full bg-muted">
          {illustration}
        </div>
        {title && (
          <Text multiline variant="display" className="mb-2">
            {title}
          </Text>
        )}
        {description && (
          <Text
            multiline
            variant="body-description"
            className="mb-6 max-w-sm text-muted-foreground"
          >
            {description}
          </Text>
        )}
        {onAction && (
          <Button onClick={onAction} variant="secondary">
            <Plus className="size-4" />
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyWidgetContent;
